import { render, staticRenderFns } from "./Partidos.vue?vue&type=template&id=40772e5a"
import script from "./Partidos.vue?vue&type=script&lang=js"
export * from "./Partidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports